declare namespace $ {

	export class $shm_button_open extends $mol_button_open {
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=open.view.tree.d.ts.map